import React, { useState } from "react";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import Videojs from "../../video-js";
import { mobileIs } from "../../../utils/siteUtils";

import "./style.scss";
const WorkMedia = (props) => {
  const { data, index, showLength } = props;
  let { video, image } = data.fields;
  const videoOptions =
    video && video.value
      ? {
          sources: [
            {
              src: video.value.src,
              type: video.value.mimeType
            }
          ],
          poster: image.value.src,
          videoTitle: '',
          autoplay: false,
          controls: true,
          muted: true
        }
      : {};
    const handleImageStatus = (e) =>{
      props.loading && props.loading(index+'media');
    }
    return (
        <div className="work-media">
          { 
          index < showLength && 
          <>
            { video && !video.value && 
              <div className="work-media-image">
                <PhotoProvider>
                  <PhotoView src={image.value.src}>
                    <img src={image.value.src} alt="" onLoad={handleImageStatus} />
                  </PhotoView>
                </PhotoProvider>
              </div>
            }
            {video && video.value &&
                <Videojs className="work-media-video" {...videoOptions} videoLoaded={handleImageStatus}/>
            }
          </>
          }
        </div>
    );
};
export default WorkMedia;
